import { post } from 'axios';
import API from '../../settings/api';
import headersWithToken from '../../scripts/helpers/headers.token';

export async function pay( store, id ) {

  try {

    const headers = headersWithToken();
    const { status, data } = await post( API.tariff.pay, {}, { headers } );

    if ( status === 200 ) {

      if ( data.success ) {

        window.location = data.redirect;
        
      } else {

        throw( data.text );

      }

    } else {

      throw('Нет соединения с сервером');

    }

  } catch ( err ) {

    console.error( err );

  }
  
}